import React, { useState } from "react";
import { Link } from "react-router-dom";
import useTermsStore from "../../store/useTermsStore";
import toast from "react-hot-toast";

const DocumentIcon = () => (
  <svg
    className="w-3.5 h-3.5 shrink-0"
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm-1 2.5L18.5 10H15a1 1 0 0 1-1-1V4.5zM8 13h8v1.5H8V13zm0 3.5h8V18H8v-1.5z" />
  </svg>
);

const Footer = () => {
  const { termsAccepted, acceptTerms } = useTermsStore();
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [isAccepted, setIsAccepted] = useState(false);

  const handleAcceptTerms = () => {
    if (!isAccepted) {
      toast.error("You must accept the Terms of Use to continue");
      return;
    }

    acceptTerms();
    setShowTermsModal(false);
    toast.success("Terms of Use accepted successfully");
  };

  const handleRejectTerms = () => {
    setShowTermsModal(false);
    toast.error("You must accept the Terms of Use to use this platform");
  };

  return (
    <>
      <footer className="relative bg-[#06061a]">
        <div
          className="h-px w-full"
          style={{
            background:
              "linear-gradient(90deg, #a855f7 0%, #6366f1 50%, #3b82f6 100%)",
          }}
        />

        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-6">
          {!termsAccepted && (
            <div className="mb-6 bg-gradient-to-br from-blue-500/10 to-purple-600/10 backdrop-blur-sm border border-blue-500/30 rounded-xl p-6">
              <h3 className="text-white text-xs font-semibold mb-4">
                Terms Acceptance Required
              </h3>
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <input
                    type="checkbox"
                    id="footer-terms-checkbox"
                    checked={isAccepted}
                    onChange={(e) => setIsAccepted(e.target.checked)}
                    className="mt-0.5 h-4 w-4 text-blue-500 focus:ring-blue-500 border-slate-400 rounded accent-blue-500"
                  />
                  <label
                    htmlFor="footer-terms-checkbox"
                    className="text-xs text-slate-200 leading-relaxed"
                  >
                    I have read and agree to the{" "}
                    <Link
                      to="/terms"
                      className="text-yellow-400 hover:text-yellow-300 underline font-medium transition-colors"
                    >
                      Terms of Use Agreement
                    </Link>
                  </label>
                </div>
                <button
                  onClick={() => setShowTermsModal(true)}
                  className="w-full px-4 py-2.5 bg-gradient-to-r from-blue-500 to-purple-600 text-white text-xs font-semibold rounded-lg hover:from-blue-600 hover:to-purple-700 transition-all duration-300 shadow-md hover:shadow-lg"
                >
                  Review & Accept Terms
                </button>
              </div>
            </div>
          )}

          <div className="space-y-2">
            <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-sm text-white">
              <span>KYC/AML Required</span>
              <span className="text-slate-500">•</span>
              <span>18+ Years Old Only</span>
              <span className="text-slate-500">•</span>
              <span>Not FDIC Insured</span>
              <span className="text-slate-500">•</span>
              <Link
                to="/terms"
                className="inline-flex items-center gap-1.5 text-yellow-400 hover:text-yellow-300 transition-colors"
              >
                <DocumentIcon />
                Terms of Use Agreement
              </Link>
            </div>

            <p className="text-sm text-white">
              Contact Email:{" "}
              <a
                href="mailto:support@P2P1.com"
                className="text-yellow-400 hover:text-yellow-300 transition-colors"
              >
               support@P2P1.com
              </a>
            </p>

            <p className="text-sm text-white">Powered by XchangeOS</p>
          </div>

          <div className="mt-4 pt-3 border-t border-white/10">
            <p className="text-xs text-white text-right">
              Operated by Monily.
            </p>
          </div>
        </div>
      </footer>

      {showTermsModal && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div
            className="rounded-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto shadow-2xl"
            style={{
              background:
                "linear-gradient(135deg, rgba(30, 41, 59, 0.98) 0%, rgba(15, 23, 42, 0.98) 100%)",
              backdropFilter: "blur(20px)",
              border: "1px solid rgba(148, 163, 184, 0.2)",
            }}
          >
            <div className="p-6">
              <div className="flex justify-between items-center ">
                <h2 className="text-xl font-semibold text-white">
                  Terms of Use Agreement
                </h2>
                <button
                  onClick={() => setShowTermsModal(false)}
                  className="text-slate-400 hover:text-white transition-colors p-1 rounded-lg hover:bg-slate-700/50"
                >
                  <svg
                    className="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>

              <div className="text-[10px] text-slate-400">
                Operated by Monily
              </div>

              <div className="bg-slate-800/60 backdrop-blur-sm border border-blue-500/20 p-4 rounded-lg mb-4">
                <p className="text-slate-200 text-[10px] leading-relaxed">
                  This User Agreement ("Agreement") governs your access to and
                  use of the website, mobile applications, and services provided
                  by B C Commerce Intl Inc s.r.o. a Company incorporated and
                  licensed in the Czech Republic 197 44 251. Located at Vlkova
                  532/8, Žižkov, 130 00 Praha 3 hereinafter referred to as the
                  company, ("the Company", "we", "our", or "us"). By registering
                  for an account, accessing, or using our services, you
                  acknowledge that you have read, understood, and agree to be
                  bound by this Agreement. If you do not agree, you must refrain
                  from using our platform.
                </p>
              </div>

              <div className="space-y-4 text-[10px]">
                <div>
                  <h3 className="font-semibold text-white mb-2">Key Points:</h3>
                  <ul className="list-disc list-inside space-y-1 ml-4 text-slate-300">
                    <li>You must be at least 18 years old</li>
                    <li>Crypto-asset trading involves high risks</li>
                    <li>KYC/AML verification is required</li>
                    <li>You are responsible for compliance with local laws</li>
                    <li>
                      Past performance is not indicative of future results
                    </li>
                  </ul>
                </div>

                <div className="bg-blue-500/10 border-l-4 border-blue-500 p-3 rounded-r-lg">
                  <p className="text-[10px] text-blue-200 mb-2">
                    <strong>Important:</strong> By using our services, you
                    acknowledge the risks of crypto-asset trading and agree to
                    use the platform at your own risk.
                  </p>
                  <p className="text-[10px] text-blue-300 font-medium">
                    For questions or concerns, contact us at:{" "}
                    <a
                      href="mailto:support@P2P1.com"
                      className="underline hover:text-blue-200 transition-colors"
                    >
                      support@P2P1.com
                    </a>
                  </p>
                </div>

                <div>
                  <h3 className="font-semibold text-white mb-2">
                    Contact Information
                  </h3>
                  <div className="bg-slate-800/60 backdrop-blur-sm border border-blue-500/20 p-3 rounded-lg">
                    <p className="text-white text-[10px] font-semibold">
                      B C Commerce Intl Inc s.r.o.
                    </p>
                    <p className="text-slate-300 text-[10px]">
                      Vlkova 532/8, Žižkov, 130 00 Praha 3
                    </p>
                    <p className="text-slate-300 text-[10px]">
                      Email: support@P2P1.com
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-6 p-4 bg-slate-800/40 backdrop-blur-sm border border-blue-500/20 rounded-lg">
                <div className="flex items-start space-x-3">
                  <input
                    type="checkbox"
                    id="modal-accept-terms"
                    checked={isAccepted}
                    onChange={(e) => setIsAccepted(e.target.checked)}
                    className="mt-1 h-4 w-4 text-blue-500 focus:ring-blue-500 border-slate-400 rounded accent-blue-500"
                  />
                  <label
                    htmlFor="modal-accept-terms"
                    className="text-[10px] text-white"
                  >
                    I have read, understood, and agree to be bound by the Terms
                    of Use Agreement. I acknowledge the risks associated with
                    crypto-asset trading and agree to use the platform at my own
                    risk.
                  </label>
                </div>
              </div>

              <div className="mt-6 flex flex-col sm:flex-row gap-3 justify-end">
                <button
                  onClick={handleRejectTerms}
                  className="px-4 py-2 bg-red-500/80 text-white text-[10px] font-semibold rounded-lg hover:bg-red-600 transition-colors shadow-md"
                >
                  Reject & Exit
                </button>
                <button
                  onClick={handleAcceptTerms}
                  disabled={!isAccepted}
                  className="px-4 py-2 bg-gradient-to-r from-blue-500 to-purple-600 text-white text-[10px] font-semibold rounded-lg hover:from-blue-600 hover:to-purple-700 disabled:from-slate-600 disabled:to-slate-700 disabled:cursor-not-allowed transition-all duration-300 shadow-md hover:shadow-lg"
                >
                  Accept Terms & Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Footer;
